export const ADD_MANUFACTURER_DETAILS = "ADD_MANUFACTURER_DETAILS";
export const FETCH_MANUFACTURER_DETAILS_LIST =
  "FETCH_MANUFACTURER_DETAILS_LIST";
export const EDIT_MANUFACTURER_DETAILS = "EDIT_MANUFACTURER_DETAILS";
export const UPDATE_MANUFACTURER_DETAILS = "UPDATE_MANUFACTURER_DETAILS";
export const DELETE_MANUFACTURER_DETAILS = "DELETE_MANUFACTURER_DETAILS";
